<div class="flex items-center justify-center w-screen h-screen {$$props.class || ''}">
    <slot/>
</div>